<template>
  <div v-if="start">
    <div class="lg:w-3/4">
      <vx-card>
        <div class="vx-card__title mb-4">
          <h2 class="mb-4">Создание виджета</h2>
        </div>
        <div class="vx-row mb-6">
          <div class="vx-col w-full lg:w-1/2 mb-2">
            <vs-input
              class="w-full"
              label="Название виджета: *"
              placeholder="Например, Аналитика переходов"
              name="name"
              v-model="name"
              v-validate="'required'"
            />
            <span class="text-danger text-sm" v-show="errors.has('name')">{{ errors.first('name') }}</span>
          </div>
          <div class="vx-col w-full lg:w-1/2 mb-2">
            <vs-input
              class="w-full"
              label="Описание виджета:"
              placeholder="Например, для сбора аналитики о переходах на сайт"
              name="description"
              v-model="description"
            />
          </div>
        </div>
        <div class="flex justify-end">
          <vs-button
            ref="loadableButton"
            id="button-with-loading"
            class="vs-con-loading__container"
            @click.prevent="submit">
            Создание виджета
          </vs-button>
        </div>
      </vx-card>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  data () {
    return {
      start: false,
      name: '',
      description: ''
    }
  },
  computed: mapGetters(['authUserCompany']),
  methods: {
    async submit () {
      const validate = await this.$validator.validateAll()

      if (validate) {
        const { status, data: { slug } } = await this.$api.Widgets.addOne(this.authUserCompany.slug, {
          name: this.name,
          description: this.description
        })

        if (status === 'success') {
          await this.$router.push({ name: 'widgets_edit', params: { widgetSlug: slug } })
        } else {
          this.$vs.notify({
            color: 'danger',
            title: 'Произошла ошибка',
            text: ''
          })
        }
      }
    }
  },
  created () {
    this.start = true
  }
}
</script>
